import {
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import API from '../../../services/API'
import BigModal from '../../../components/Modals/BigModal'
import ConsequenceSelector from './ConsequenceSelector'
import LikelihoodSelector from './LikelihoodSelector'
import SuccessModal from '../../../components/Modals/Success'
import SelectUser from '../../../components/Forms/Select/SelectUser'
import categoryOptions from './categoryOptions'
import CqcLinkageFields from './CqcLinkageFields'
import { useCqcStatements } from './cqcLinkage'

const SectionLabel = ({ children }) => (
  <Typography
    variant="smallGrey"
    sx={{
      textTransform: 'uppercase',
      letterSpacing: '0.14em',
      fontWeight: 600,
      fontSize: '0.72rem',
      color: 'third.main',
    }}
  >
    {children}
  </Typography>
)

const AddNewRisk = ({ open, onClose }) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [category, setCategory] = useState('')
  const [initialRatingConsequence, setInitialRatingconsequence] = useState('')
  const [initialRatingLikelihood, setInitialRatingLikelihood] = useState('')
  const [mitigation, setMitigation] = useState('')
  const [actions, setActions] = useState('')
  const [targetRatingConsequence, setTargetRatingConsequence] = useState('')
  const [targetRatingLikelihood, setTargetRatingLikelihood] = useState('')
  const [submitSuccess, setSubmitSuccess] = useState(false)
  const [managerOptions, setManagerOptions] = useState([])
  const [selectedManager, setSelectedManager] = useState('')
  const [cqcActivityType, setCqcActivityType] = useState(null)
  const [cqcQualityStatementKeys, setCqcQualityStatementKeys] = useState([])
  const { statements, keyQuestions } = useCqcStatements()

  const handleSubmit = (e) => {
    e.preventDefault()
    const formValues = {
      title,
      description,
      category,
      initialRatingConsequence,
      initialRatingLikelihood,
      mitigation,
      actions,
      targetRatingConsequence,
      targetRatingLikelihood,
      riskOwner: selectedManager,
      cqcActivityType,
      cqcQualityStatementKeys,
    }
    API.post('/riskregister', formValues)
      .then((res) => res.status === 200 && setSubmitSuccess(true))
      .catch((e) => {
        console.log(e)
      })
  }

  useEffect(() => {
    API.post('/users-in-team', { team: ['Governance', 'Manager'] })
      .then((res) => setManagerOptions(res.data))
      .catch((e) => console.log(e))
  }, [])

  return (
    <BigModal open={open} onClose={onClose}>
      <Box
        display="flex"
        flexDirection="column"
        gap={1.5}
        component="form"
        onSubmit={handleSubmit}
        overflow="auto"
        maxHeight="90vh"
        width="100%"
      >
        <Box>
          <Typography variant="title3">Add a New Risk</Typography>
          <Typography variant="smallGrey">
            New risks appear on the register immediately and feed the CQC Centre as evidence.
          </Typography>
        </Box>

        <SectionLabel>Risk details</SectionLabel>
        <TextField
          label="Risk Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          autoComplete="off"
          required
        />
        <TextField
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="If (cause), then (event), which may result in (consequence)."
          multiline
          minRows={3}
          required
        />
        <FormControl>
          <InputLabel id="category-label">Category</InputLabel>
          <Select
            labelId="category-label"
            id="category"
            value={category}
            label="Category"
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            {categoryOptions.map((x) => (
              <MenuItem key={x} value={x}>
                {x}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Divider />
        <SectionLabel>Scoring</SectionLabel>
        <Box display="flex" gap={1}>
          <ConsequenceSelector
            value={initialRatingConsequence}
            onChange={(e) => setInitialRatingconsequence(e.target.value)}
            label="Initial Consequence"
            required
          />
          <LikelihoodSelector
            value={initialRatingLikelihood}
            onChange={(e) => setInitialRatingLikelihood(e.target.value)}
            label="Initial Likelihood"
            required
          />
        </Box>
        <Box display="flex" gap={1}>
          <ConsequenceSelector
            value={targetRatingConsequence}
            onChange={(e) => setTargetRatingConsequence(e.target.value)}
            label="Target Consequence"
            required
          />
          <LikelihoodSelector
            value={targetRatingLikelihood}
            onChange={(e) => setTargetRatingLikelihood(e.target.value)}
            label="Target Likelihood"
            required
          />
        </Box>

        <Divider />
        <SectionLabel>Controls</SectionLabel>
        <TextField
          value={mitigation}
          onChange={(e) => setMitigation(e.target.value)}
          label="Mitigation"
          autoComplete="off"
          multiline
          minRows={2}
        />
        <TextField
          value={actions}
          onChange={(e) => setActions(e.target.value)}
          label="Actions Required"
          autoComplete="off"
          multiline
          minRows={2}
        />
        <SelectUser
          options={managerOptions}
          value={selectedManager}
          onChange={(e) => setSelectedManager(e.target.value)}
          label="Responsible Manager"
          required
        />

        <Divider />
        <SectionLabel>CQC Centre linkage</SectionLabel>
        <CqcLinkageFields
          activityType={cqcActivityType}
          onActivityChange={setCqcActivityType}
          statementKeys={cqcQualityStatementKeys}
          onStatementKeysChange={setCqcQualityStatementKeys}
          statements={statements}
          keyQuestions={keyQuestions}
        />

        <Button type="submit" variant="contained" color="primary">
          Add Risk
        </Button>
      </Box>
      <SuccessModal open={submitSuccess} newUrl="/risk-register" />
    </BigModal>
  )
}

export default AddNewRisk
